/** Expand #rgb to #rrggbb. Returns '' when `value` is not a hex colour. */
export const toPickerHex = (value, fallback = '#000000') => {
  const raw = String(value || '').trim();
  if (/^#[0-9a-f]{6}$/i.test(raw)) return raw.toLowerCase();
  if (/^#[0-9a-f]{3}$/i.test(raw)) {
    const h = raw.slice(1).toLowerCase();
    return `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`;
  }
  if (typeof document !== 'undefined' && raw) {
    const ctx = document.createElement('canvas').getContext('2d');
    if (ctx) {
      const probe = '#123456';
      ctx.fillStyle = probe;
      ctx.fillStyle = raw;
      if (ctx.fillStyle !== probe || raw.toLowerCase() === probe) return ctx.fillStyle;
    }
  }
  return fallback;
};
